// @flow

export default {
  TOGGLE_SCROLLBAR_STATE: 'toggleScrollbarState',
  ALLOW_SCROLLBAR: 'allowScrollbar',
  DISALLOW_SCROLLBAR: 'disallowScrollbar',
  ADD_PAGE_INTERACTION: 'addPageInteraction',
  REMOVE_PAGE_INTERACTION: 'removePageInteraction',
  SCROLL: 'scroll',
  SELECT_PRODUCT: 'selectProduct',
  CHANGE_PRODUCT: 'changeProduct',
  UPDATE_PRODUCT_AMOUNT: 'updateProductAmount',
  UPDATE_CAROUSEL_MEDIA: 'updateCarouselMedia',
  UPDATE_CAROUSEL_BULLETS: 'updateCarouselBullets',
  CAROUSEL_CHANGE_INDEX: 'carouselChangeIndex',
  CAROUSEL_SCROLL_SLIDER: 'carouselScrollSlider',
  CAROUSEL_ADD_SCROLL_LISTENER: 'carouselAddScrollListener',
  CAROUSEL_UPDATE_NAVIGATION: 'carouselUpdateNavigation',
  RESIZE: 'resize',
  TOGGLE_MODAL: 'toggleModal',
  CAROUSEL_YT_STATE_CHANGE: 'carouselYoutubeStateChange',
  CAROUSEL_CHILDREN_UPDATE: 'carouselChildrenUpdate',
  ACTIVATE_TAB: 'activateTab',
  CHANGE_TAB: 'changeTab',
  VOTE_UPDATE: 'voteUpdate',
  SLIDE: 'slide',
  PAGINATE: 'paginate',
  PAGINATED: 'paginated',
  SORT: 'sort',
  SORTED: 'sorted',
  TOGGLE_FILTER: 'toggleFilters',
  TOGGLE_SUB_FILTER: 'toggleSubFilters',
  FILTERS_BUILT: 'filtersBuilt',
  FILTER: 'filter',
  FILTERED: 'filtered',
  ASYNC_FAILED: 'asyncFailed',
  LOAD: 'load',
  LOADED: 'loaded',
  CART_ADD_ITEM: 'cartAddItem',
  CART_UPDATE_ITEM: 'cartUpdateItem',
  CART_REMOVE_ITEM: 'cartRemoveItem',
  CART_UPDATE_DATA: 'cartUpdateData',
  CART_SHOW_TOTAL_COUNTER: 'showTotalCartCounter',
  CART_SHOW_PROMOTION_REWARDS: 'showPromotionRewards',
  CART_HIDE_PROMOTION_REWARDS: 'hidePromotionRewards',
  SHOW_EMPTY_CART: 'showEmptyCart',
  HIDE_EMPTY_CART: 'hideEmptyCart',
  COUPON_ADD: 'addCoupon',
  COUPON_REMOVE: 'removeCoupon',
  COUPON_INVALID: 'couponInvalid',
  COUPON_UPDATE_DATA: 'couponUpdateData',
  UPDATE_DELIVERY_METHOD: 'updateDeliveryMethod',
  UPDATE_DELIVERY_MOMENT: 'updateDeliveryMoment',
  ADDRESS_UPDATE: 'addressUpdate',
  ADDRESS_INVALID: 'addressInvalid',
  ADDRESS_OVERWRITE: 'addressOverwrite',
  ADDRESS_OVERWRITTEN: 'addressOverwritten',
  ADDRESS_CANCEL: 'addressCancel',
  BILLING_ADDRESS_PRE_FILLED: 'billingAddressPreFilled',
  DELIVERY_ADDRESS_PRE_FILLED: 'deliveryAddressPreFilled',
  LOOK_UP_ADDRESS: 'lookUpAddress',
  LOOK_UP_ADDRESS_DONE: 'lookUpAddressDone',
  REQUEST_TIME_FRAMES_DONE: 'timeFramesDone',
  UPDATE_AGENDA: 'updateAgenda',
  FIND_PICKUP_POINTS: 'findPickupPoints',
  FOUND_PICKUP_POINTS: 'foundPickupPoints',
  CHANGE_PAYMENT_METHOD: 'changePaymentMethod',
  TOGGLE_VIEW_PANEL: 'toggleViewPanel',
  CLEAR_VIEW_PANEL: 'clearViewPanel',
  CHECK_BOX: 'checkBox',
  CHECKBOX_UPDATE: 'checkboxUpdate',
  VALIDATE: 'validate',
  FOCUS_ON_SEARCH: 'focusOnSearch',
  FOCUSED_ON_SEARCH: 'focusedOnSearch',
  CLEARED_SEARCH_KEYWORD: 'clearedSearchKeyword',
  HIDE_SEARCH_SUGGESTIONS: 'hideSearchSuggestions',
  UPDATE_SEARCH_SUGGESTIONS: 'updateSearchSuggestions',
  ACCEPT_DISCLAIMER: 'acceptDisclaimer',
  ZOOMED: 'zoomed',
  RESET_ZOOM: 'resetZoom',
  RESETTED_ZOOM: 'resettedZoom',
  RESET_DELIVERY_ADDRESS: 'resetDeliveryAddress',
  PRODUCTS_FOUND: 'productsFound',
  PRODUCTS_NOT_FOUND: 'productsNotFound',
  SEARCH_SUGGESTION_TOUCH: 'searchSuggestionTouch',
  DISPATCH_EVENT: 'dispatchEvent',
  SHOW_PROMOTION: 'showPromotion',
  HIDE_PROMOTION: 'hidePromotion',
  SHOW_PRODUCT_ORDERABLE: 'showProductOrderable',
  HIDE_PRODUCT_ORDERABLE: 'hideProductOrderable',
  TOGGLE_ADDRESS: 'toggleAddress',
  UPDATE_PREFERRED_SHIPPING_COUNTRY: 'updatePreferredShippingCountry',
  SHOW_MORE_REVIEWS: 'showMoreReviews',
  COOKIES_CHANGED: 'cookiesChanged',
  UPDATE_NAVIGATION_FORM_STEP: 'updateNavigationFormStep',
  UPDATE_PROGRESS: 'updateProgress',
  CLEAR_ACTIVE_SEARCH_ITEMS: 'clearActiveSearchItems',
  SHOW_CART_NOTIFICATION: 'showCartNotification',
  INPUT_CHANGED: 'inputChanged',
  ACTIVE_SEARCH_ITEMS_CHANGED: 'activeSearchItemsChanged',
  NEXT_SEARCH_SUGGESTION: 'nextSearchSuggestion',
  PREVIOUS_SEARCH_SUGGESTION: 'previousSearchSuggestion',
  SEARCH_SUGGESTION_CHOSEN: 'searchSuggestionChosen',
  TOGGLE_ACCORDION: 'toggleAccordion',
  EMPTY_IDS_FROM_FETCH: 'emptyIdsFromFetch',
  UPDATE_FEATURED_REVIEW: 'updateFeaturedReview',
  SHOW_FEATURED_REVIEW: 'showFeaturedReview',
  SHOW_LEFT_SLIDER_BUTTON: 'showLeftSliderButton',
  SHOW_RIGHT_SLIDER_BUTTON: 'showRightSliderButton',
  HIDE_LEFT_SLIDER_BUTTON: 'hideLeftSliderButton',
  HIDE_RIGHT_SLIDER_BUTTON: 'hideRightSliderButton',
  UPDATE_SUBSCRIPTION_PERIOD: 'updateSubscriptionPeriod',
  UPDATE_PRODUCT_COUNTER: 'updateProductCounter',
  EXCEEDED_MAXIMUM_ORDER_PRICE: 'exceededMaximumOrderPrice',
  MINIMUM_ORDER_PRICE_REACHED: 'minimumPriceReached',
  MAXIMUM_ORDER_ALLOWED: 'maximumOrderAllowed',
  MINIMUM_ORDER_ALLOWED: 'minimumOrderAllowed',
  SUBSCRIPTION_PERIOD_CHANGED: 'subscriptionPeriodChanged',
  ADD_OVERLAY_PICKUP_POINT_MAP: 'addOverlayPickupPointMap',
  TOGGLE_SATURDAY_DELIVERY: 'toggleSaturdayDelivery',
  TOGGLE_SAME_DAY_DELIVERY: 'toggleSameDayDelivery',
  TOGGLE_WAREHOUSE_PICKUP: 'toggleWarehousePickup',
  UPDATE_PICKUP_POINT: 'updatePickupPoint',
  PICKUP_POINT_CLICK: 'pickupPointClick',
  UPDATE_CONTENT_HEIGHT: 'updateContentHeight',
  UPDATE_HORIZONTAL_SLIDER_BUTTON_HEIGHT: 'updateHorizontalSliderButtonHeight',
  ACTIVATE_PARENT_TOGGLE: 'activateParentToggle',
  START_PAYMENT: 'startPayment',
  UPDATE_PICK_UP_COUNTRY: 'updatePickUpCountry',
  SITE_SPECT_OPEN_PRODUCT_INFORMATION: 'siteSpectOpenProductInformation',
  ROBIN_CHAT_OPEN: 'robinChatOpen',
  ROBIN_CHAT_CLOSE: 'robinChatClose',
  SHOW_REPEAT_BANNER: 'showRepeatBanner',
  HIDE_REPEAT_BANNER: 'hideRepeatBanner',
  UPDATE_PAYMENT_FEE: 'UpdatePaymentFee',
  SHOW_ADD_TO_CART_NOTIFICATION: 'showAddToCartNotification',
  CROSS_SELL_UPDATE_DATA: 'crossSellUpdateData',
  SUBSCRIPTION_PERIOD_ADD_REQUIRED_MESSAGE: 'subscriptionPeriodAddRequiredMessage',
  PRODUCT_SKU_CHANGED: 'productSkuChanged'
};
